import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Deposit Manager Page", -1)

import { AuthorisationLevel } from "@/config/AuthConfig";
import { authService } from "@/auth/authSingleton";

export default /*#__PURE__*/_defineComponent({
  __name: 'DepositManager',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("p", null, " This is the Deposit Manager Page. Only users with \"Deposit Manager Group\" authorisation and above (>=" + _toDisplayString(_unref(AuthorisationLevel).DepositManager) + ") can view this page. ", 1),
    _createElementVNode("p", null, " Your're authorisation level is " + _toDisplayString(_unref(authService).getUsersRole()) + " (" + _toDisplayString(_unref(AuthorisationLevel)[_unref(authService).getUsersRole()]) + "). ", 1)
  ]))
}
}

})